import { SearchResult } from '@rygen/rygen-ui/model';

import { ShipmentSearchData } from './ShipmentSearchData';

export class ShipmentSearchResult extends SearchResult<ShipmentSearchData> {
  content: ShipmentSearchData[] = [];
  start?: number;

  constructor(opts?: Partial<ShipmentSearchResult>) {
    super(opts);

    if (opts?.content != null) {
      this.content = opts.content.map((val) => new ShipmentSearchData(val));
    }
    if (opts?.start != null) {
      this.start = opts.start;
    }
  }
}
